if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      if (this.querySelector('form')) {
        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }
      else {
        this.querySelector('[name=id]').disabled = false;
        this.querySelector('button[type=submit]').addEventListener('click', this.onSubmitHandler.bind(this));
      }
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      // --- Addon support ---
      // If product-addon blocks exist on the page, bundle the main product +
      // resolved addon variants into a single multi-item /cart/add.js call.
      const hasAddons = window.ProductAddons && document.querySelector('[data-product-addons-block]');
      console.log('🟢[ADDON] onSubmitHandler · ProductAddons present:', !!window.ProductAddons,
        '· addon block on page:', !!document.querySelector('[data-product-addons-block]'),
        '→ path:', hasAddons ? 'submitWithAddons' : 'STOCK single-item');
      if (hasAddons) {
        return this.submitWithAddons();
      }

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (!this.form) {
        formData.append('id', this.querySelector('[name=id]').value);
      }

      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message});
            this.handleErrorMessage(response.description);
            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: formData.get('id')});
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    submitWithAddons() {
      const self = this;

      console.log('🟢[ADDON] submitWithAddons() start · blocks registered:',
        (window.ProductAddons && window.ProductAddons.blocks ? window.ProductAddons.blocks.length : 'N/A'),
        '· form id:', self.form && self.form.id);

      // Make sure each addon block has resolved its variant against the
      // currently-selected main product variant before reading them.
      Promise.resolve(window.ProductAddons.syncAll())
        .then(() => {
          const formData = new FormData(self.form);
          const mainId = formData.get('id') || self.querySelector('[name=id]').value;
          const quantity = parseInt(formData.get('quantity'), 10) || 1;

          // Collect line item properties from the form (name="properties[...]")
          const mainProperties = {};
          for (const [key, value] of formData.entries()) {
            const match = key.match(/^properties\[(.+)\]$/);
            if (match) mainProperties[match[1]] = value;
          }

          // Drop the internal `__addon_<blockid>` keys from the main product –
          // they're for the radio state, not the actual cart line.
          Object.keys(mainProperties).forEach((k) => {
            if (k.indexOf('__addon_') === 0) delete mainProperties[k];
          });

          const items = [{
            id: parseInt(mainId, 10),
            quantity: quantity,
            properties: Object.keys(mainProperties).length ? mainProperties : undefined
          }];

          // Resolve main product title from the page if available
          const titleEl = document.querySelector('.product__title') || document.querySelector('[itemprop="name"]');
          const mainTitle = titleEl ? titleEl.textContent.trim() : '';

          const addonItems = window.ProductAddons.getCartItems(mainTitle) || [];
          addonItems.forEach((it) => items.push(it));

          console.log('🟢[ADDON] resolved addonItems:', JSON.stringify(addonItems));
          console.log('🟢[ADDON] POST /cart/add payload items:', JSON.stringify(items));

          const payload = { items: items };
          if (self.cart) {
            payload.sections = self.cart.getSectionsToRender().map((s) => s.id);
            payload.sections_url = window.location.pathname;
            self.cart.setActiveElement(document.activeElement);
          }

          return fetch(`${routes.cart_add_url}`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify(payload)
          }).then((r) => r.json()).then((response) => ({ response: response, mainId: mainId }));
        })
        .then((result) => {
          const response = result && result.response;
          const mainId = result && result.mainId;

          console.log('🟢[ADDON] add response · status:', response && response.status,
            '· items added:', response && response.items ? response.items.length : (response && response.item_count),
            '· has sections:', !!(response && response.sections),
            '· section keys:', response && response.sections ? Object.keys(response.sections) : null);

          if (response && response.status) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-form',
              productVariantId: self.querySelector('[name=id]').value,
              errors: response.description,
              message: response.message
            });
            self.handleErrorMessage(response.description || response.message);
            const soldOutMessage = self.submitButton.querySelector('.sold-out-message');
            if (soldOutMessage) {
              self.submitButton.setAttribute('aria-disabled', true);
              self.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              self.error = true;
            }
            return;
          }

          if (!self.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          self.error = false;
          const mainVariantId = parseInt(mainId, 10);

          // Notify other cart listeners. Published BEFORE the drawer re-renders
          // (matches stock behaviour) so the soon-to-be-replaced drawer items
          // element absorbs it, not the freshly rendered one.
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'product-form',
            productVariantId: self.querySelector('[name=id]').value
          });

          // Primary path: use the sections the bulk /cart/add.js already
          // rendered — same mechanism the theme uses for single-item adds, and
          // rendered against the final cart so it includes every addon. `id` is
          // set to the main variant so the drawer's "item added" highlight
          // resolves and doesn't null-deref in the notification branch.
          if (response && response.sections && response.sections['cart-drawer']) {
            console.log('🟢[ADDON] rendering drawer from ADD-RESPONSE sections');
            if (!response.id) response.id = mainVariantId;
            self.cart.renderContents(response);
            return;
          }

          // Fallback: the add response didn't include usable sections, so
          // re-fetch them fresh via the Section Rendering API.
          const sectionIds = self.cart.getSectionsToRender().map((s) => s.id);
          const sectionsUrl = window.location.pathname + '?sections=' + sectionIds.join(',');
          console.log('🟢[ADDON] add-response had no cart-drawer section — fetching fresh:', sectionsUrl);
          return fetch(sectionsUrl)
            .then((r) => r.json())
            .then((sections) => {
              console.log('🟢[ADDON] fresh sections fetched · keys:', sections ? Object.keys(sections) : null);
              self.cart.renderContents({ id: mainVariantId, sections: sections });
            })
            .catch((err) => {
              console.log('🟢[ADDON] fresh section fetch failed — reloading', err);
              // Last resort: reload so the drawer reflects the real cart.
              window.location.reload();
            });
        })
        .catch((e) => { console.error(e); })
        .finally(() => {
          self.submitButton.classList.remove('loading');
          if (self.cart && self.cart.classList.contains('is-empty')) self.cart.classList.remove('is-empty');
          if (!self.error) self.submitButton.removeAttribute('aria-disabled');
          const spinner = self.querySelector('.loading-overlay__spinner');
          if (spinner) spinner.classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
